// extracted by mini-css-extract-plugin
export var attachmentContainer = "_mg-0";
export var fileList = "_mg-2";
export var removeFileButton = "_mg-1";